
require('es6-promise').polyfill();

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueAnalytics from 'vue-analytics'
import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();

Vue.config.productionTip = false

Vue.use(VueAnalytics, {
    id: 'UA-60134962-1',
    router
});

Vue.prototype.$bus = new Vue();

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')
